import { render, staticRenderFns } from "./bindMailbox.vue?vue&type=template&id=9e33fd76&scoped=true&"
import script from "./bindMailbox.vue?vue&type=script&lang=js&"
export * from "./bindMailbox.vue?vue&type=script&lang=js&"
import style0 from "./bindMailbox.vue?vue&type=style&index=0&id=9e33fd76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e33fd76",
  null
  
)

export default component.exports